<template>
<div id="ediPreview" v-html="ediPreview">
</div>
</template>

<script>
import axios from 'axios'
import cheerio from 'cheerio'
export default {
    data: () => ({
        ediPreview: '<div id="loadingText" class="white--text">Loading EDI Invoice...<div>'
    }),
    created() {
        if (this.$route.query.attachmentId && this.$route.query.messageId) {
            this.loadEDIPreview()
        }
    },
    methods: {
        async loadEDIPreview() {
            const {
                attachmentId,
                messageId
            } = this.$route.query
            try {
                let response = await this.$http.get(`/gmail/attachment?attachmentId=${attachmentId}&messageId=${messageId}&format=html`);
                const $ = cheerio.load(response.data)
                this.ediPreview = $('body').html()
            } catch (error) {
                console.log(error)
            }
        }
    }
}
</script>

<style scoped>
@import url('../../assets/css/ediInvoice.css');
</style>
